import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useTemplateRef, onMounted, onUnmounted } from "vue";
import { NutrientDocumentAuth } from "@/types/types";
import { $api } from "@/services/api1";
import { usePdfViewerModalStore } from "@/store/store/pdfViewerModalStore";


export default /*@__PURE__*/_defineComponent({
  __name: 'PdfViewerNutrient',
  props: {
    docId: {},
    splitView: { type: Boolean }
  },
  setup(__props: any) {

const containerRef = useTemplateRef("container");
let NutrientSDK: typeof window.NutrientViewer | undefined;

const props = __props;

const pdfViewerModalStore = usePdfViewerModalStore();

async function getTokenData(docId: number): Promise<NutrientDocumentAuth> {
  return await $api.documents.getNutrientToken(docId);
}

onMounted(async () => {
	if (!props.docId) {
		return;
	}
  NutrientSDK = window.NutrientViewer;
  const container = containerRef.value;
  const resp = await getTokenData(props.docId);

  if (container && NutrientSDK) {
    NutrientSDK.load({
      container,
      useCDN: true,
      authPayload: { jwt: `${resp.venderToken}`},
      documentId: `${resp.vendorId}`,
      instant: false,
      licenseKey: resp.licenseKey,
      serverUrl: `${resp.serverUrl}`
    }).then((doc) => {
      pdfViewerModalStore.pdfModal.pageCount = doc.totalPageCount;
    })
    .catch((error: any) => {
      console.error(error);
    });
  }
});

onUnmounted(() => {
  const container = containerRef.value;
  if (container && NutrientSDK) {
    NutrientSDK.unload(container);
  }
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref: "container",
    class: _normalizeClass(props.splitView ? 'split-view-pdf-viewer' : 'responsive-pdf-viewer')
  }, null, 2))
}
}

})